<div class="avatar-stack d-flex">
    <div *ngIf="avatarArray?.length">
        <ng-container *ngFor="let avatar of avatarArray?.slice(0, 4); let i = index">
            @if(avatar.photo_url){
            <img [src]="avatar.photo_url"
                class="rounded-circle avatar border border-2 border-snow-white position-relative"
                [style.zIndex]="avatarArray?.length - i" alt="member" width="20" height="20">
                
            } @else {
            <img src="assets/images/default-user.svg"
                class="rounded-circle avatar border  border-2 border-snow-white position-relative"
                [style.zIndex]="avatarArray?.length - i" alt="member" width="20" height="20">
            }

        </ng-container>
    </div>
    <span *ngIf="avatarArray?.length > 4"
        class="rounded-circle avatar text-secondary-grey d-flex justify-content-center align-items-center  border border-2 border-snow-white remaining"
        [style.zIndex]="1">
        +{{ avatarArray?.length - 4 }}
    </span>
</div>